module.exports = __webpack_public_path__ + "img/qr-google-play.d7581c5c.png";